<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border spinner-border-sm"></div>
    </div>
    <div v-else-if="results">
      <div class="row g-3 mb-4 text-center">
        <div class="col-4">
          <small class="text-muted d-block">Destinatários</small>
          <strong class="fs-4">{{ results.recipients }}</strong>
        </div>
        <div class="col-4">
          <small class="text-muted d-block">Responderam</small>
          <strong class="fs-4">{{ results.answered }}</strong>
        </div>
        <div class="col-4">
          <small class="text-muted d-block">Taxa de resposta</small>
          <strong class="fs-4">{{ results.response_rate }}%</strong>
        </div>
      </div>

      <div
        v-for="q in results.questions"
        :key="q.id"
        class="card mb-3"
      >
        <div class="card-header d-flex align-items-center gap-2">
          <strong>{{ q.title }}</strong>
          <span v-if="q.required" class="badge bg-primary-soft">Obrigatória</span>
          <span class="text-muted small ms-auto">{{ q.answered }} resposta(s)</span>
        </div>
        <div class="card-body">
          <!-- Escolha única: pizza (mutuamente exclusivo) -->
          <div v-if="q.type === 'single_choice'" class="chart-box">
            <ChartDoughnut :data="chartData(q.options)" />
          </div>

          <!-- Múltipla escolha: barra (soma passa de 100%, pizza não serve) -->
          <template v-else-if="q.type === 'multiple_choice'">
            <p class="text-muted small">
              Cada pessoa pode marcar mais de uma alternativa — a soma dos
              percentuais passa de 100%.
            </p>
            <div class="chart-box">
              <ChartBar :data="chartData(q.options)" />
            </div>
          </template>

          <!-- Texto aberto: lista de respostas -->
          <div v-else>
            <p v-if="!q.answers?.length" class="text-muted mb-0">
              Ninguém respondeu essa pergunta ainda.
            </p>
            <ul v-else class="list-unstyled mb-0 open-answers">
              <li v-for="(a, i) in q.answers" :key="i" class="mb-2 pb-2 border-bottom">
                “{{ a.value }}”
                <div class="text-muted small">
                  {{ a.respondent }} · {{ formatDate(a.answered_at) }}
                </div>
              </li>
            </ul>
            <p v-if="q.answers?.length >= 200" class="text-muted small mt-2 mb-0">
              Mostrando as 200 respostas mais recentes.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doughnut } from "@/utils/dashboardCharts";

export default {
  name: "SurveyResults",
  props: {
    uuid: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      results: null,
    };
  },
  mounted() {
    this.fetchResults();
  },
  methods: {
    async fetchResults() {
      this.loading = true;
      try {
        const res = await this.$surveyAdminService.results(this.uuid);
        this.results = res.data;
      } catch (e) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: e.message || "Erro ao carregar os resultados.",
        });
      } finally {
        this.loading = false;
      }
    },
    chartData(options) {
      return doughnut(options || [], "label", "count");
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
</script>

<style scoped>
.open-answers {
  max-height: 400px;
  overflow-y: auto;
}

.chart-box {
  position: relative;
  height: 260px;
}
</style>
